import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addaccounttype',
  templateUrl: './addaccounttype.component.html',
  styleUrls: ['./addaccounttype.component.css']
})
export class AddaccounttypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  accounttypeColl: any = [];
  accountgroupColl: any = [];

  accounttypeform = new FormGroup({
    accounttypeid: new FormControl(0),
    accounttypename: new FormControl('', Validators.required),
    accountsgroupid: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "LedgerType";

  @Input() accounttypeid: number = 0
  @Input() accounttypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.accounttypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('accounttypename');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.accounttypeform.reset();
      this.fnInitializeAccounttype();

      if (this.accounttypeid > 0) {
        this.fngetAccounttype();
      }
      this.fngetAccountGroup()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.accounttypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    //this.isadjtypeaddmode = this.loginService.fnCheckUserRoleAction("AdjType", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeAccounttype() {
    this.accounttypeform.setValue({

      accounttypeid: 0,
      accounttypename: '',
      accountsgroupid:null,
      inactive:false,
    })
  }
  fngetAccountGroup() {
    var data = {
      'accountgroupid': 0,
    }
    this.appService.getAccountgroup(data)
      .subscribe(
        (res) => {
          this.accountgroupColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetAccounttype() {
   
    var data = {
      'accounttypeid': this.accounttypeid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getAccounttype(data)
      .subscribe(
        (res) => {
          this.accounttypeColl = res.json().result;
          var editdata = this.accounttypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.accounttypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'accounttypeid': this.accounttypeid,
          'accounttypename': this.accounttypeform.get('accounttypename').value,
          'accountsgroupid': this.accounttypeform.get('accountsgroupid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.accounttypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckAccounttype(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.accounttypeform.get('accounttypeid').value > 0) {
                //Update Department
                this.fnSetAccounttype(data);
              }
              else {
                //Insert Department
                this.fnInsertAccounttype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.accounttypeform.controls['accounttypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAccounttype(data) {
  
    this.appService.fnInsertAccounttype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnaccounttypeid = 0;
          if (result.length > 0) {
            rtnaccounttypeid = result[0].accounttypeid
           
          }
          this.toastr.success('', "The new accounttype has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.accounttypeid);

          this.emitData.emit(rtnaccounttypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAccounttype(data) {

    this.appService.fnSetAccounttype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The accounttype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.accounttypeid, data.accounttypename);

          this.emitData.emit(this.accounttypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.accounttypeform.setValue({

      accounttypeid: deptBO.accounttypeid,
      accounttypename: deptBO.accounttypename,
      accountsgroupid: deptBO.accountsgroupid,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
